var version = "4.18.0";

export { version };
//# sourceMappingURL=package.json.js.map
